module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4zq7c"))).then(() => parcelRequire('37nVf'));